import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const YearInput = (props) => {
  const { error } = props;
  const datePickerRef = useRef(null); // Ref for the DatePicker input
  // const [startDate, setStartDate] = useState();

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus(); // Programmatically focus the DatePicker
    }
  };

  return (
    <div className="picker_box">
      <i className="fa fa-calendar" onClick={handleIconClick} style={{ cursor: "pointer" }} />
      <DatePicker
        ref={datePickerRef}
        type="date"
        {...props}
        // selected={startDate}
        // onChange={(date) => {
        //   setStartDate(date || null);
        //   props.onChange?.(date || null); // Pass to the parent onChange handler
        // }}
        placeholderText="Select a date"
      />
      {error ? (
        <p style={{ paddingTop: 5, fontSize: 13, color: "red" }}>
          {error}
        </p>
      ) : null}
    </div>
  );
};

export default YearInput;